module.exports = __webpack_public_path__ + "img/state1.65cc92f1.webp";